// extracted by mini-css-extract-plugin
module.exports = {"title":"ProductList_title__3_n6u","category":"ProductList_category__1qy-y"};